
import { Button } from "@/components/ui/button";
import { PackagePlus } from "lucide-react";

interface AddPolicyButtonProps {
  onClick: () => void;
}

export const AddPolicyButton = ({ onClick }: AddPolicyButtonProps) => {
  return (
    <div className="bg-white border border-gray-200 p-8 rounded-2xl">
      <label className="cursor-pointer">
        <div 
          onClick={onClick}
          className="bg-white border border-[#9b87f5] rounded-xl p-6 flex flex-col items-center gap-2 hover:bg-gray-50 transition-colors cursor-pointer"
        >
          <PackagePlus className="h-6 w-6 text-[#9b87f5]" />
          <span className="text-[#9b87f5] font-medium">Add New Policy</span>
        </div>
      </label>
    </div>
  );
};
